<template>
    <b-modal size='lg' scrollable no-fade id="modal-history" ref="modal-history" title="Histórico">
        <b-row>
            <b-col lg="12">
            </b-col>
        </b-row>
        <b-row>
            <b-col lg="12">
                <b-table show-empty empty-text="Sem dados para exibir" small :items="history" :fields="fields" striped bordered head-variant="dark">
                </b-table>
            </b-col>
        </b-row>
        <template v-slot:modal-footer>
            <b-button size="sm" @click="() => $bvModal.hide('modal-history')">Fechar</b-button>
        </template>
    </b-modal>
</template>

<script>
import {baseApiUrl, showError, formatDate } from '@/global'
import axios from 'axios'

export default {
    name: 'FileHistory',
    props: ["file"],
    data: function(){
        return {
            history: [],
            fields: [
                {key:'dt_historico', label: 'Data/Hora', formatter: function(val){
                    return formatDate(val, "YYYY/MMM/DD HH:mm:ss", "DD/MM/YY HH:mm")
                }},
                {key: 'usuario_id', label: 'Usuário'},
                {key: 'historico', label: 'Histórico'}

            ]
        }
    },
    methods: {
        getHistory(){
            if(!this.file.arquivo_id)
                return
            else{
                axios.get(`${baseApiUrl}/arquivos/${this.file.arquivo_id}/historico`)
                    .then(
                        resp => this.history = resp.data
                    )
                    .catch(ex => showError(ex))
            }
        }
    },
    watch :{
        // eslint-disable-next-line
        file: function(newVal, oldVal){
            if(newVal)
                this.getHistory()
        }
    },
    mounted(){
        this.getHistory()
    }
}
</script>

<style>

</style>